import { createContext, useContext, useEffect } from "react"
import type { ReactNode } from "react"
import { useAccountAlias } from "resources/account"
import { ComposerControlsContext } from "./composer-chrome"
import { useAttachmentUploads } from "./use-attachment-uploads"
import { useKellyChat } from "./kelly-chat-context"

const AttachmentSendGateContext = createContext(false)

export function useAttachmentSendGate(): boolean {
  return useContext(AttachmentSendGateContext)
}

export function ComposerAttachmentsProvider({ children }: { children?: ReactNode }) {
  const accountAlias = useAccountAlias()
  const { activeThreadId, registerAttachmentUploads } = useKellyChat()
  const uploads = useAttachmentUploads({ accountAlias, threadId: activeThreadId })
  const { attachmentBlockedRef } = useContext(ComposerControlsContext)

  useEffect(() => {
    registerAttachmentUploads(uploads)
    return () => registerAttachmentUploads(null)
  }, [registerAttachmentUploads, uploads])

  // The surface's submit handlers sit above ChatBox and read this ref.
  useEffect(() => {
    attachmentBlockedRef.current = uploads.hasBlockingError
    return () => {
      attachmentBlockedRef.current = false
    }
  }, [attachmentBlockedRef, uploads.hasBlockingError])

  return <AttachmentSendGateContext.Provider value={uploads.hasBlockingError}>{children}</AttachmentSendGateContext.Provider>
}
